import {Dispatch, FC, SetStateAction} from "react";
import {IconDefinition} from "@fortawesome/fontawesome-common-types";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

export const IconStore: FC<{ iconList: [string, IconDefinition][],  selected: string, setSelected: Dispatch<SetStateAction<string>>}> = (props) => {
  return <>
    <h1 className={'text-sm font-medium text-brand-900 py-0.5'}>Selecteer een icoon</h1>
    <div className={'bg-white border border-slate-200 rounded-xs grid 2xl:grid-cols-7 xl:grid-cols-6 lg:grid-cols-5 md:grid-cols-3 gap-2 overflow-y-scroll px-2 py-2'}>
      {props.iconList.map((icon, i) => {
        return <IconCard key={i} icon={icon} selected={props.selected} setSelected={props.setSelected} />
      })}
    </div>
  </>
}

const IconCard: FC<{ icon: [string, IconDefinition], selected: string, setSelected: Dispatch<SetStateAction<string>> }> = (props) => {
  const [name, icon] = props.icon
  return <div className={`px-4 py-4 border ${(props.selected === name) ? 'border-brand-600 bg-brand-100' : 'border-slate-200 bg-white'} rounded-xs flex justify-center items-center hover:bg-brand-50 hover:cursor-pointer`} onClick={() => props.setSelected(name)}>
    <FontAwesomeIcon icon={icon} className={'text-brand-600 text-4xl'} />
  </div>
}